import { hasOwnProviderCredentials } from "./paymentProviderStatus";

/**
 * Backend generates a merchant–PSP agreement only after credentials are saved.
 * Either credentials store may be populated depending on which request ran.
 */
export function hasSavedPspCredentials({ credentials, paymentCredentials } = {}) {
	if (paymentCredentials?.value) return true;
	return credentials != null;
}

/** Credentials belong to the business's currently selected payment provider. */
export function hasCurrentProviderCredentials({ credentials, paymentCredentials, provider } = {}) {
	if (!provider) return hasSavedPspCredentials({ credentials, paymentCredentials });
	if (hasOwnProviderCredentials(credentials, provider)) return true;
	if (hasOwnProviderCredentials(paymentCredentials, provider)) return true;
	return Boolean(paymentCredentials?.value && paymentCredentials?.provider === provider);
}

/** Recent merchant agreement is waiting on the authorised signatory (`status === "SENT"`). */
export function hasPendingSignatureRequest(signingPending) {
	return Boolean(signingPending);
}

/** Invite, share, and live collection are only allowed when the current provider is fully live. */
export function isLiveCollectionReady({
	business,
	credentials,
	paymentCredentials,
	signingPending,
} = {}) {
	if (!business?.verified) return false;
	if (hasPendingSignatureRequest(signingPending)) return false;
	return hasCurrentProviderCredentials({
		credentials,
		paymentCredentials,
		provider: business?.pmtProvider,
	});
}

/** Agreement-signing UI is only valid after PSP credentials have been saved. */
export function isAgreementSigningVisible(signingPending, payswitchState) {
	return Boolean(hasPendingSignatureRequest(signingPending) && hasSavedPspCredentials(payswitchState));
}
